// File: src/components/auth/LoginButton.tsx
// FIXED: Тип onSuccess теперь соответствует тому, что возвращает хук useGoogleLogin.

import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { useGoogleLogin, TokenResponse } from '@react-oauth/google';
import { useTranslation } from 'react-i18next';
import GoogleIcon from '@mui/icons-material/Google';

interface LoginButtonProps {
    onSuccess: (tokenResponse: TokenResponse) => void;
    onError: () => void;
    isLoading?: boolean;
}

const LoginButton: React.FC<LoginButtonProps> = ({ onSuccess, onError, isLoading }) => {
    const { t } = useTranslation();

    const login = useGoogleLogin({
        onSuccess: onSuccess,
        onError: onError,
    });

    return (
        isLoading ? (
            <CircularProgress size={24} />
        ) : (
            <Button
                onClick={() => login()}
                variant="outlined"
                startIcon={<GoogleIcon />}
                sx={{
                    color: 'text.primary',
                    borderColor: 'divider',
                    '&:hover': {
                        borderColor: 'primary.main',
                        color: 'primary.main',
                    },
                }}
            >
                {t('auth.sign_in')}
            </Button>
        )
    );
};

export default LoginButton;
